import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SiteBanner = () => {
  // Define a function to check if we're on mobile
  const isMobile = () => {
    if (typeof window !== 'undefined') {
      return window.innerWidth <= 768;
    }
    return false;
  };

  // Custom CSS for mobile responsiveness
  const mobileStyles = {
    bannerHeading: {
      padding: '20px 0',
      textAlign: 'center'
    },
    bannerTitle: {
      fontSize: '2.5rem',
      marginBottom: '20px'
    },
    bannerDescription: {
      fontSize: '1rem',
      marginBottom: '30px'
    },
    bannerCta: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '15px'
    },
    secondButton: {
      marginLeft: '0'
    },
    carouselContainer: {
      maxWidth: '90%',
      margin: '30px auto 0'
    }
  };

  return (
    <section
      className="site-banner"
      id="home"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: "#173222", // Deep green background color
        padding: "100px 0 50px", // Reduced bottom padding for mobile
      }}
    >
      <Container>
        <Row className="align-items-center">
          <Col lg={6}>
            {/* - Banner Heading - */}
            <div className="banner-heading" style={{ 
              padding: "40px 0",
              ...(isMobile() ? mobileStyles.bannerHeading : {})
            }}>
              <div className="banner-text mb-5">
                <div className="banner-subtitle">
                  <h3
                    style={{
                      color: "#d4c19c", // Gold/cream color
                      fontWeight: "500",
                      letterSpacing: "2px",
                      marginBottom: "20px",
                      textTransform: "uppercase",
                      fontSize: "1rem",
                    }}
                  >
                    Premium Poyabzallar
                  </h3>
                </div>
                <div className="banner-title">
                  <h1
                    style={{
                      fontSize: "4rem",
                      fontWeight: "700",
                      lineHeight: "1.2",
                      marginBottom: "30px",
                      color: "#ffffff", // White text for main heading
                      ...(isMobile() ? mobileStyles.bannerTitle : {})
                    }}
                  >
                    Nafislikka <br />
                    <span className="highlight" style={{ color: "#d4c19c" }}>
                      Qadam tashlang
                    </span>
                  </h1>
                </div>
                <div className="banner-description">
                  <p
                    style={{
                      fontSize: "1.25rem",
                      color: "#e0e0e0", // Light gray for better readability on dark background
                      lineHeight: "1.8",
                      marginBottom: "40px",
                      ...(isMobile() ? mobileStyles.bannerDescription : {})
                    }}
                  >
                    Bizning premium poyabzallar kolleksiyamizni kashf eting,
                    <br />
                    bu yerda qulaylik ajoyib dizayn bilan uchrashuvi.
                  </p>
                </div>
              </div>

              <div className="banner-cta" style={{
                ...(isMobile() ? mobileStyles.bannerCta : {})
              }}>
                <Link
                  to="/#generalFeatures"
                  className="btn btn-lg"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .getElementById("generalFeatures")
                      .scrollIntoView({ behavior: "smooth" });
                  }}
                  style={{
                    padding: "15px 40px",
                    borderRadius: "30px",
                    fontWeight: "600",
                    backgroundColor: "#d4c19c", // Gold/cream button
                    color: "#173222", // Dark green text
                    border: "none",
                    boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
                    transition: "all 0.3s ease",
                  }}
                >
                  Hozir xarid qilish
                </Link>
                <Link
                  to="#about"
                  className="btn btn-lg ms-4"
                  style={{
                    padding: "15px 40px",
                    borderRadius: "30px",
                    fontWeight: "600",
                    backgroundColor: "transparent",
                    color: "#d4c19c", // Gold/cream text
                    border: "2px solid #d4c19c", // Gold/cream border
                    transition: "all 0.3s ease",
                    ...(isMobile() ? mobileStyles.secondButton : {})
                  }}
                >
                  Bizning hikoya
                </Link>
              </div>
            </div>
            {/* - Banner Heading - */}
          </Col>

          <Col lg={6} className="mt-lg-0 mt-5">
            <div
              className="banner-image"
              style={{
                position: "relative",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  width: "400px",
                  height: "400px",
                  borderRadius: "50%",
                  background: "rgba(212, 193, 156, 0.1)", // Gold/cream with low opacity
                  zIndex: "0",
                }}
              ></div>
              
              <div style={{ 
                width: "100%", 
                maxWidth: "500px", 
                margin: "0 auto", 
                zIndex: "1",
                ...(isMobile() ? mobileStyles.carouselContainer : {})
              }}>
                <Slider
                  dots={true}
                  infinite={true}
                  speed={500}
                  slidesToShow={1}
                  slidesToScroll={1}
                  autoplay={true}
                  autoplaySpeed={3000}
                  pauseOnHover={true}
                  className="banner-carousel"
                >
                  <div>
                    <img 
                      src={require("../assets/images/skechers/premium1.png")} 
                      alt="Premium Shoe 1" 
                      style={{ 
                        width: "100%", 
                        height: "auto", 
                        borderRadius: "15px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.3)"
                      }} 
                    />
                  </div>
                  <div>
                    <img 
                      src={require("../assets/images/skechers/premium2.png")} 
                      alt="Premium Shoe 2" 
                      style={{ 
                        width: "100%", 
                        height: "auto", 
                        borderRadius: "15px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.3)"
                      }} 
                    />
                  </div>
                  <div>
                    <img 
                      src={require("../assets/images/skechers/premium3.png")} 
                      alt="Premium Shoe 3" 
                      style={{ 
                        width: "100%", 
                        height: "auto", 
                        borderRadius: "15px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.3)"
                      }} 
                    />
                  </div>
                  <div>
                    <img 
                      src={require("../assets/images/skechers/premium4.png")} 
                      alt="Premium Shoe 4" 
                      style={{ 
                        width: "100%", 
                        height: "auto", 
                        borderRadius: "15px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.3)"
                      }} 
                    />
                  </div>
                </Slider>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiteBanner;
